import * as Sentry from '@sentry/vue'

export const useHandleException = () => {
  const handleException = (ex: unknown, captureException: boolean = true) => {
    if (captureException) {
      try {
        try {
          Sentry.captureException(ex)
        }
        catch {
          // @ts-expect-error: Unreachable code error
          // https://github.com/getsentry/sentry-javascript/issues/7441
          Sentry.default.captureException(ex)
        }
      }
      catch (ex: unknown) {
        // Fallback to native error in case if Sentry is failed

        console.error(ex)
      }
    }
  }

  return {
    handleException,
  }
}
